import { useUserService } from "../services";

export function useGuestDecline() {
  const service = useUserService();

  return (
    contactId: string,
    meetingId: string,
    orgId: string,
    turnstileToken?: string | null,
  ): Promise<void> => {
    const body: Record<string, string> = {
      a: "decline",
      c: contactId,
      m: meetingId,
      o: orgId,
    };
    if (turnstileToken) {
      body.tt = turnstileToken;
    }
    return service
      .post(`/api/meeting/guest/action`)
      .send(body)
      .then((res: Response) => res.body);
  };
}
